export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  path: string,
  init?: RequestInit & { json?: unknown },
): Promise<T> {
  const headers = new Headers(init?.headers);
  let body: BodyInit | null = (init?.body as BodyInit | null | undefined) ?? null;
  if (init?.json !== undefined) {
    headers.set('Content-Type', 'application/json');
    body = JSON.stringify(init.json);
  }

  const response = await fetch(path, {
    method: init?.method ?? (init?.json !== undefined ? 'POST' : 'GET'),
    headers,
    body,
    credentials: 'same-origin',
  });

  let payload: unknown = null;
  if (response.headers.get('content-type')?.includes('application/json')) {
    payload = await response.json();
  }

  if (!response.ok) {
    const message =
      typeof payload === 'object' && payload && 'message' in payload
        ? String((payload as { message: unknown }).message)
        : `Request failed: ${response.status}`;
    throw new ApiError(response.status, message, payload);
  }

  return payload as T;
}
